import { useCallback, useRef } from 'react';
import { useOnIntersectingChange } from '@shared/utils/hooks/useOnIntersectingChange';
import { useGetPdpProductCollectionById } from '../../../../api/queries/getPdpProductCollectionById';
import { UseRelatedProductCollectionsSectionArgs } from './types';

export const useRelatedProductCollectionsSection = ({ collectionDisplayInfos, selectedProductId }: UseRelatedProductCollectionsSectionArgs) => {
  const { collectionsList, fetchCollections, loading: loadingCollections } = useGetPdpProductCollectionById({ selectedProductId });
  const familyShelfRef = useRef<HTMLDivElement>(null);
  const hasIntersected = useRef<boolean>(false);

  // Fetch collections when scroll down until familyShelfRef is intercepted
  const onIntersectingShelf = useCallback(
    (isIntersecting: boolean) => {
      if (isIntersecting && !hasIntersected.current) {
        hasIntersected.current = true;
        if (!!collectionDisplayInfos.length) {
          const collectionsRefList = collectionDisplayInfos.map(ref => ({
            displayInfoId: ref.displayInfoId,
            pdpSectionType: ref.pdpSectionType ?? ''
          }));
          fetchCollections({
            collectionsRefList
          });
        }
      }
    },
    [collectionDisplayInfos, fetchCollections]
  );
  useOnIntersectingChange(familyShelfRef, onIntersectingShelf);

  return { collectionsList, loadingCollections, familyShelfRef };
};
